import { useState } from 'react';
import axios from 'axios';

const HodCommentFormContent = ({ isDataColumnHOD, token }) => {
    const [checkedItems, setCheckedItems] = useState({});
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [loading, setLoading] = useState(false);
    const {REACT_APP_API_BACKEND_URL_EXIT_FORM } = process.env;


    const handleChange = (event) => {
        const { name, checked } = event.target;
        setCheckedItems(prevState => ({
            ...prevState,
            [name]: checked,
        }));
    };

    const handleSelectAll = (event) => {
        const { checked } = event.target;
        const newCheckedItems = {};
        isDataColumnHOD.forEach(item => {
            newCheckedItems[item.fieldName] = checked;
        });
        setCheckedItems(newCheckedItems);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        setLoading(true);

        const selectedItems = Object.keys(checkedItems).filter(item => checkedItems[item]);

        if (!startDate || !endDate || selectedItems.length === 0) {
            alert('Please select a start date, end date, and at least one item.');
            setLoading(false);
            return;
        }

        const payload = {
            startDate: startDate,
            endDate: endDate,
            columnField: selectedItems


        };

        try {
            const url = REACT_APP_API_BACKEND_URL_EXIT_FORM + "export/hod/excel";
            console.log(url);
            const response = await axios.post(url, payload, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
                responseType: 'blob'
            });

            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const urlBlob = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = urlBlob;
            link.download = 'HOD_Comment_Form.xlsx';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(urlBlob);

        } catch (error) {
            console.error('An unexpected error occurred:', error);
        } finally {
            setLoading(false);
        }
    };

    const areAllChecked = isDataColumnHOD.every(item => checkedItems[item.fieldName] || false);

    const renderRows = () => {
        const rows = [];
        for (let i = 0; i < isDataColumnHOD.length; i += 5) {
            const rowItems = isDataColumnHOD.slice(i, i + 5);
            rows.push(
                <tr key={i}>
                    {rowItems.map(item => (
                        <td key={item.fieldName}>
                            <label className="checkbox-label">
                                <input
                                    type="checkbox"
                                    name={item.fieldName}
                                    checked={checkedItems[item.fieldName] || false}
                                    onChange={handleChange}
                                />
                                {item.displayName}
                            </label>
                        </td>
                    ))}
                </tr>
            );
        }
        return rows;
    };

    return (
        <form onSubmit={handleSubmit}>
            <div style={{ margin: "12px", paddingBottom: '10px' }}>
                Filter Date From:
                <input
                    style={{ padding: '10px', margin: '10px' }}
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                />
                To:
                <input
                    style={{ padding: '10px', margin: '10px' }}
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                />
            </div>
            <table className="checkbox-table">
                <thead>
                    <tr>
                        <th colSpan="5">
                            <input
                                type="checkbox"
                                onChange={handleSelectAll}
                                checked={areAllChecked}
                            />
                            Select All
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {renderRows()}
                </tbody>
            </table>
            <div>
                {loading && <div>Loading...</div>} {/* Conditional rendering for loading indicator */}
                <button style={{ marginTop: "42px" }} type="submit" className='btn-primary' disabled={loading}>
                    {loading ? 'Generating Report...' : 'Generate Report'}
                </button>
            </div>
        </form>
    );
};

export default HodCommentFormContent;
